import { createContext, ReactNode, useContext } from 'react'

import { AccountVestingTypeEnum } from 'constants/vesting'

interface AccountVestingContextType {
  type?: AccountVestingTypeEnum
}

const AccountVestingContext = createContext<AccountVestingContextType>({})

interface AccountVestingContextProps {
  type: AccountVestingTypeEnum
  children: ReactNode
}
const AccountVestingProvider: React.FC<AccountVestingContextProps> = ({ type, children }) => {
  return (
    <AccountVestingContext.Provider
      value={{
        type,
      }}
    >
      {children}
    </AccountVestingContext.Provider>
  )
}

const useAccountVestingContext = (): AccountVestingContextType => {
  const context = useContext(AccountVestingContext)

  if (context === undefined) {
    throw new Error('Context not available')
  }

  return context
}

export { AccountVestingProvider, useAccountVestingContext }
